import React from 'react';
import { AlertsDetailFill, SuccessFill, InfoFill, WarningSquare } from '@elliemae/ds-icons';

export const icons = {
  success: <SuccessFill color={['success', 900]} width="24px" height="24px" />,
  info: <InfoFill color={['brand-primary', 600]} width="24px" height="24px" />,
  error: <AlertsDetailFill color={['danger', 900]} width="24px" height="24px" />,
  warning: <WarningSquare color={['warning', 900]} width="24px" height="24px" />,
};
